__turbopack_context__.v({
  "mask": "Fade-module-scss-module__2Jz5WG__mask",
});
